/// <reference path='../../_references.ts' />
module onvio.setup.importExportTest {
    'use strict';

    export class ImportExportTestController {

    }

    angular.module('onvio.setup.importExportTest', [])
        .controller('ImportExportTestController', ImportExportTestController);
}
